/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.setting.defs'

export { $nsid }

type Option = {
  $type?: 'tools.ozone.setting.defs#option'
  key: l.NsidString
  did: l.DidString
  value: l.LexMap
  description?: string
  createdAt?: l.DatetimeString
  updatedAt?: l.DatetimeString
  managerRole?:
    | 'tools.ozone.team.defs#roleModerator'
    | 'tools.ozone.team.defs#roleTriage'
    | 'tools.ozone.team.defs#roleAdmin'
    | 'tools.ozone.team.defs#roleVerifier'
    | l.UnknownString
  scope: 'instance' | 'personal' | l.UnknownString
  createdBy: l.DidString
  lastUpdatedBy: l.DidString
}

export type { Option }

const option = /*#__PURE__*/ l.typedObject<Option>(
  $nsid,
  'option',
  /*#__PURE__*/ l.object({
    key: /*#__PURE__*/ l.string({ format: 'nsid' }),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    value: /*#__PURE__*/ l.lexMap(),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 1024, maxLength: 10240 }),
    ),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    managerRole: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'tools.ozone.team.defs#roleModerator',
          'tools.ozone.team.defs#roleTriage',
          'tools.ozone.team.defs#roleAdmin',
          'tools.ozone.team.defs#roleVerifier',
        ]
      }>(),
    ),
    scope: /*#__PURE__*/ l.string<{ knownValues: ['instance', 'personal'] }>(),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    lastUpdatedBy: /*#__PURE__*/ l.string({ format: 'did' }),
  }),
)

export { option }
